// '/pure' avoids loading Stripe.js just from importing this module - it
// only starts the network fetch once loadStripe() is actually called.
import { loadStripe } from '@stripe/stripe-js/pure';

const stripePublishableKey =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  'pk_test_C74igWNlVunW4YYX1Q7IQTaf';

// Shared across every caller (Checkout, OrderEdit, Payments...) so Stripe.js
// is only ever fetched once per session, however many payment entry points
// get used - calling loadStripe() again per-render/per-mount was creating a
// fresh promise (and re-triggering the load) every time.
let stripeInstancePromise = null;
export const getStripePromise = () => {
  if (!stripeInstancePromise) {
    stripeInstancePromise = loadStripe(stripePublishableKey);
  }
  return stripeInstancePromise;
};
